import { methods } from "../enums/index.js";
import { apiAction } from "./index.js";

export const messageDataPost = data => ["/message", methods.POST, data];
export const messageDelete = id => [`/message/${id}`, methods.DELETE];
export const messageFilterByEntryAndSubordinateGet = (entryId = "", subordinateId = "", search = "", page = 1, limit = 100, sort = "-createdAt", filter = "") => apiAction(
  `/message/filter-by-entry-and-subordinate/${entryId}/${subordinateId}/?search=${search}&page=${page}&limit=${limit}&sort=${sort}&filter=${filter}`,
);
